import React, { PropsWithChildren } from 'react';
import { identifyComponent } from '../../../util';

export const TableBodyBase: React.FunctionComponent<PropsWithChildren<unknown>> = ({
  children,
  ...rest
}) => (
  <tbody data-component="TableBodyBase" {...rest} {...identifyComponent('table-body-base', rest)}>
    {children}
  </tbody>
);
